module.exports = __webpack_public_path__ + "img/F11P_spj.fc5a529a.png";